















import {Component, Vue} from "vue-property-decorator";
import GameOptions from '@/components/GameOptions.vue';
import {GameConfig} from "@/components/types/GameConfig";

@Component({
    components: {GameOptions}
})
export default class PlayVsComputer extends Vue {
    onPlayClick(gameConfig: GameConfig): void {
        this.$router.push({
            path: '/computer',
            query: {
                width: gameConfig.width.toString(),
                height: gameConfig.height.toString(),
                mines: gameConfig.mines.toString(),
                speed: gameConfig.speed.toString(),
                lives: gameConfig.lives.toString(),
            },
        });
    }
}
